import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Garden pond on a 2x2 tile patch: a low square stone rim ring around a
// water slab (surface at ~0.1), with a couple of loose rim stones.
const STONE = "#8d8a85";
const STONE_LIGHT = "#9b9791";
const WATER = "#6fa8c0";

export const gardenPond = defineModel({
  id: "garden-pond",
  batchId: "modern",
  name: "Garden pond",
  tags: ["modern", "outdoor", "garden", "pond", "water"],
  summary: "A stone-rimmed garden pond about 1.8 metres across.",
  description:
    "A garden pond of the Modern Living kit: ~1.8 m across on a 2x2 tile " +
    "patch — a low stone rim ring around a water slab whose surface sits at " +
    "y=0.1, with a couple of loose rim stones for character.",
  tiles: { w: 2, h: 2 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // Stone rim ring: four low boxes framing the water.
      { geometry: new THREE.BoxGeometry(1.8, 0.16, 0.18), color: STONE, position: [0, 0.08, 0.81] },
      { geometry: new THREE.BoxGeometry(1.8, 0.16, 0.18), color: STONE, position: [0, 0.08, -0.81] },
      { geometry: new THREE.BoxGeometry(0.18, 0.16, 1.44), color: STONE, position: [0.81, 0.08, 0] },
      { geometry: new THREE.BoxGeometry(0.18, 0.16, 1.44), color: STONE, position: [-0.81, 0.08, 0] },
      // Water slab, surface at y = 0.1 (just below the rim).
      { geometry: new THREE.BoxGeometry(1.44, 0.1, 1.44), color: WATER, position: [0, 0.05, 0] },
      // Loose rim stones.
      {
        geometry: new THREE.IcosahedronGeometry(0.1, 0),
        color: STONE_LIGHT,
        position: [0.66, 0.19, 0.78],
      },
      {
        geometry: new THREE.IcosahedronGeometry(0.08, 0),
        color: STONE_LIGHT,
        position: [-0.78, 0.18, -0.6],
      },
    ];
  },
  animations: [],
});
